import * as Types from '../generated/types';

import gql from 'graphql-tag';
import * as Urql from '@/urql/urqlWrapper';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type INoopMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type INoopMutation = { __typename?: 'Mutation', noop?: void | null };


export const NoopDocument = gql`
    mutation Noop {
  noop
}
    `;

export function useNoopMutation() {
  return Urql.useMutation<INoopMutation, INoopMutationVariables>(NoopDocument);
};